import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendClickSoundCommand } from '../../helpers/web_to_client'

import styles from './Paginator.css'

const propTypes = {
    total: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    current: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    onPrevClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired,
    prevTooltipId: PropTypes.string,
    nextTooltipId: PropTypes.string,
}

class Paginator extends React.PureComponent {
    constructor(props) {
        super(props)

        this.handlePrevClick = this.handlePrevClick.bind(this)
        this.handleNextClick = this.handleNextClick.bind(this)
    }

    handlePrevClick() {
        this.props.onPrevClick()
    }

    handleNextClick() {
        this.props.onNextClick()
    }

    render() {
        const classNamePrev = classNames(styles.control, styles['control__prev'], {
            [styles.isDisabled]: this.props.current <= 1,
        })

        const classNameNext = classNames(styles.control, styles['control__next'], {
            [styles.isDisabled]: this.props.current >= this.props.total,
        })

        const prevDataAttrs = this.props.prevTooltipId ? {
            'data-tip': true,
            'data-for': this.props.prevTooltipId,
        } : {}

        const nextDataAttrs = this.props.nextTooltipId ? {
            'data-tip': true,
            'data-for': this.props.nextTooltipId,
        } : {}

        const isPrevEnabled = this.props.current > 1
        const isNextEnabled = this.props.current < this.props.total
        return (
            <div className={styles.base}>
                <span
                    {...prevDataAttrs}
                    className={classNamePrev}
                    onClick={isPrevEnabled ? this.handlePrevClick : null}
                    onMouseDown={isPrevEnabled ? sendClickSoundCommand : null}
                    onMouseEnter={sendHoverSoundCommand}
                    tabIndex="-1"
                />
                <span className={styles.current}>{this.props.current}</span>
                <span className={styles.divider}>/</span>
                <span className={styles.total}>{this.props.total}</span>
                <span
                    {...nextDataAttrs}
                    className={classNameNext}
                    onClick={isNextEnabled ? this.handleNextClick : null}
                    onMouseDown={isNextEnabled ? sendClickSoundCommand : null}
                    onMouseEnter={sendHoverSoundCommand}
                    tabIndex="-1"
                />
            </div>
        )
    }
}

Paginator.propTypes = propTypes

export default Paginator



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Paginator/Paginator.jsx